import { FETCH_RESERVATIONS_REQUEST, FETCH_RESERVATIONS_SUCCESS, FETCH_RESERVATIONS_ERROR } from '../constants/ActionTypes'

export default function isFetchingReservations(state = false, action) {
    switch (action.type) {
        case FETCH_RESERVATIONS_REQUEST:
            return true
        case FETCH_RESERVATIONS_SUCCESS:
        case FETCH_RESERVATIONS_ERROR:
            return false
        default:
            return state
    }
}
